import type { KeyboardEventHandler, ReactNode } from 'react';
import {
	type FieldValues,
	FormProvider,
	type SubmitHandler,
	type UseFormReturn,
} from 'react-hook-form';

interface FormProps<T extends FieldValues> {
	/** The instance from `useForm()`. */
	form: UseFormReturn<T>;
	onSubmit: SubmitHandler<T>;
	children: ReactNode;
	className?: string;
	id?: string;
	/** Optional key handler on the form (e.g. a Cmd/Ctrl+Enter submit shortcut). */
	onKeyDown?: KeyboardEventHandler<HTMLFormElement>;
}

/** Puts a `useForm()` instance in context for the field components and handles submit. */
export function Form<T extends FieldValues>({
	form,
	onSubmit,
	children,
	className,
	id,
	onKeyDown,
}: FormProps<T>) {
	return (
		<FormProvider {...form}>
			<form
				id={id}
				className={className}
				onSubmit={form.handleSubmit(onSubmit)}
				onKeyDown={onKeyDown}
				noValidate
			>
				{children}
			</form>
		</FormProvider>
	);
}
